import React, { Component } from 'react';
import { Table } from "react-bootstrap";

import { MatInscritasDir } from "../../funciones/EstudiantesFunction";

import MatEstRetiro from "./MatEstRetiro";

class DatosMateriaEst extends Component {
    state = {
        preloadInsc: {
            icon: "fa fa-spinner fa-spin",
            text: "Buscando materias inscritas"
        },
        materiasInscritas: []
    }

    componentDidMount = () => {
        this.consultaInicial()
    }

    consultaInicial = () => {
        MatInscritasDir(this.props.idEst, (resp) => {
            if (resp.length > 0){
                this.setState({
                    materiasInscritas: resp,
                })
            }else{
                this.setState({
                    preloadInsc: {
                        icon: "fa fa-times",
                        text: "Este estudiante no tiene materias inscritas"
                    },
                })
            }
        });
    }

    render() {
        let {materiasInscritas, preloadInsc} = this.state
        const styles = {
            padding: 5, fontSize: 12
        }

        let materiasInsc = () => {
            if (materiasInscritas.length === 0) return (
                <tr>
                    <td colSpan={6} align="center"><i className={preloadInsc.icon}></i> {preloadInsc.text}</td>
                </tr>
            )

            return (
                materiasInscritas.map(option => (
                    <MatEstRetiro key={option.id} data= {option} update = {()=> {this.consultaInicial()}}/>
                ))
            )
        }

        
        return (
            <React.Fragment>
                <div className="table-responsive" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: "50vh"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td align="center" width="45%" style={styles}><strong>Materia</strong></td>
                                <td width="10%" align="center" style={styles}><strong>Sección</strong></td>
                                <td align="center" width="15%" style={styles}><strong>Modalidad</strong></td>
                                <td align="center" width="15%" style={styles}><strong>Semestre</strong></td>
                                <td align="center" width="15%" style={styles}><strong>Acciones</strong></td>
                                <td align="center" width="20px" style={styles}></td>
                            </tr>
                            {materiasInsc()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        );
    }
}
 
export default DatosMateriaEst;


// WEBPACK FOOTER //
// ./src/views/Registros/DatosMateriaEst.jsx